<template>
    <div>
      <header>
        <h3>Pregnancy Complications</h3>
      </header>

      <div class="content">
        <div class="form__row--x" v-if="!isClose">
          <label normal>
            Present or newly diagnosed condition caused by or causing complication to the current diagnosis, must be added as here.
          </label>
          <smd-select v-model="morbiditiesModel"
                      :hide-tags="true"
                      :hide-selected="true"
                      :options="mutiSelectLookup"
                      @open="onSelectOpen"
                      @search-change="onSearchChange"/>
        </div>

        <template v-if="showContent">
          <div class="data-entry">
            <label>Category</label>
            <label>Condition</label>
          </div>

          <div class="data-entry" v-for="(value, key) in morbidities" :key="key">
            <p><strong>{{ value.categoryId | decodeMorbidities }}</strong></p>
            <p>{{ key | decodeMorbidityCondition }}</p>
            <smd-btn icon="smd-icon-action-delete"
                     @click="removeMultiSelectItem(key)"
                     v-if="!isClose"/>
          </div>
        </template>
      </div>
    </div>
</template>

<script>
  import caseFormMultiSelectMixin from './case-form-section-with-multiselect'

  import {mapActions, mapGetters} from 'vuex'
  import {
    ACTION_UPDATE_MORBIDITY,
    GETTER_IS_CLOSE
  } from '../../../store/forms/case-form-state'
  import {
    REF_MATERNAL_FETAL_FORM_MORBIDITIES,
    REF_MATERNAL_FETAL_FORM_MORBIDITIES_OBJ
  } from "../../../store/modules/referencedata2";

  export default {
    mixins: [caseFormMultiSelectMixin],
    props:{
      morbidities: null
    },
    computed:{
      ...mapGetters({
        isClose: GETTER_IS_CLOSE
      }),
      morbiditiesModel: {
        get() {
          return this.generateMultiSelectModel();
        },
        set(v) {
          const model = this.transformMultiSelectModel(v);
          this.doUpdateMultiSelectModel(model);
        }
      },
      showContent(){
        return !!Object.keys(this.morbidities).length;
      }
    },
    methods: {
      ...mapActions({
        doUpdateMultiSelectModel: ACTION_UPDATE_MORBIDITY
      }),
      getRawModelForMultiSelect() {
        return this.morbidities;
      },
      onSelectOpen() {
        this.$emit('add');
      },
      onSearchChange(q) {
        this.$emit('search-change', q);
      }
    },
    multiSelectFormSection: 'morbidities',
    multiSelectLookupName: REF_MATERNAL_FETAL_FORM_MORBIDITIES,
    multiSelectConditionsLookupName: REF_MATERNAL_FETAL_FORM_MORBIDITIES_OBJ
  }
</script>
